import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../../../services/api';

// Fetch installation members from the backend
export const useInstallationMembers = () => {
  return useQuery({
    queryKey: ['installation-members'],
    queryFn: async () => {
      try {
        const response = await api.get('/installation-members');
        return response.data?.data || [];
      } catch {
        return [];
      }
    }
  });
};

// Fetch track order data for a customer
export const useTrackOrderData = (customerId) => {
  return useQuery({
    queryKey: ['track-order', customerId],
    queryFn: async () => {
      const response = await api.get(`/track-order/customer/${customerId}`);
      return response.data?.data || null;
    },
    enabled: !!customerId
  });
};

// Assign an installation member to a customer's track order
export const useAssignMember = (customerId) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ memberId, orderId, estimationId }) => {
      const response = await api.post(`/track-order/customer/${customerId}/assign`, {
        memberId,
        orderId,
        estimationId
      });
      // Return full response so caller can check alreadyAssigned flag
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['track-order', customerId] });
    }
  });
};

// Post a work update for an assigned member
export const usePostUpdate = (customerId) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ memberId, updateData }) => {
      const response = await api.post(
        `/track-order/customer/${customerId}/member/${memberId}/update`,
        updateData
      );
      return response.data?.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['track-order', customerId] });
    }
  });
};
